import { render, staticRenderFns } from "./blog12.vue?vue&type=template&id=18fdd61a"
import script from "./blog12.vue?vue&type=script&lang=js"
export * from "./blog12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports